import { Action, FileActions } from './file-actions';
import { tassign } from 'tassign';
import { File, initialFile } from './file-state.model';

/**
* FileReducer Will excecute the according triggered in the dispatcher
* @param state Store model
* @param action The action that will affect the store
**/
export const FileReducer = function (state: File = initialFile, action: Action): File {
  const file: File = action.payload;
  switch (action.type) {
    case FileActions.SET_UPLOADED_FILEDATA:
      return tassign(state, { uploadedFiledata: file.uploadedFiledata });
    case FileActions.SUBMIT_FILE:
      return tassign(state, { isFileSubmitted: file.isFileSubmitted });
    case FileActions.SET_FILENAME:
      return tassign(state, { fileName: file.fileName });
    case FileActions.SET_FILETYPE:
      return tassign(state, { fileType: file.fileType });
    case FileActions.SET_REVIEW_APPROVED:
      return tassign(state, { reviewApproved: file.reviewApproved });
    case FileActions.SET_GENERATION:
      return tassign(state, { generation: file.generation });
    case FileActions.SET_SUPPORTED_GENERATION:
      return tassign(state, { supportedGenerations: file.supportedGenerations });
    case FileActions.SET_PACKAGE_GENERATION:
      return tassign(state, {
        packageGeneration: file.packageGeneration,
        productGeneration: '', asiGeneration: '', asiproductGeneration: ''
      });
    case FileActions.SET_PRODUCT_GENERATION:
      return tassign(state, {
        productGeneration: file.productGeneration,
        packageGeneration: '', asiGeneration: '', asiproductGeneration: ''
      });
    case FileActions.SET_ASI_GENERATION:
      return tassign(state, {
        asiGeneration: file.asiGeneration,
        packageGeneration: '', productGeneration: '', asiproductGeneration: ''
      });
    case FileActions.SET_ASI_PRODUCT_GENERATION:
      return tassign(state, {
        asiproductGeneration: file.asiproductGeneration,
        packageGeneration: '', productGeneration: '', asiGeneration: ''
      });
    default:
      return state;
  }
};


